import React from 'react'
import { SpaceFilter } from './style'
import { Select, DatePicker } from 'antd'
import PartnerDropdown from '../../PartnerDropdown';
import moment from 'moment'

const { RangePicker } = DatePicker
const Filters = ({ setLender, lender_list, partner_list, setPartners, dateFormat, setRangeDate, rangeDate }) => {
  return (<>
    <SpaceFilter>
      <Select
        style={{
          width: '300px',
          height: '35px'
        }}
        defaultValue={[{ id: 0, value: '', label: 'ผู้ให้สินเชื่อทั้งหมด' }]}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label ?? '').includes(input)}
        placeholder="เลือกผู้ให้สินเชื่อ"
        onChange={(select) => setLender(select)}
        options={[{ id: 0, value: '', label: 'ผู้ให้สินเชื่อทั้งหมด' }, ...lender_list]} />
      <RangePicker
        style={{
          width: 280,
        }}
        size={'middle'}
        format={dateFormat}
        defaultValue={[moment(rangeDate[0]), moment(rangeDate[1])]}
        onChange={(event) => { setRangeDate([event[0]._d, event[1]._d]); console.log(event) }}
      />
    </SpaceFilter>
    <PartnerDropdown partners={partner_list} setPartners={setPartners} mt={'8px'} />
  </>)
}

export default Filters
